import * as React from 'react';

import classNames from 'classnames';

import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import styles from './funnel-chart.module.css';

type Props = {
    value: number;
    valueSubtitle: string;
    valuePrefix?: string;
    onClick?: () => void;
    width: number;
    isHoverable?: boolean;
};

export const FunnelBar = (props: Props) => {
    const funnelBarStyle = classNames(styles['funnel-bar'], {
        [styles['funnel-bar--hoverable']]: props.isHoverable,
    });

    return (
        <div style={{width: `${props.width}%`}} onClick={props.onClick} className={funnelBarStyle}>
            <Stack alignItems='center'>
                <Body size='xlarge' isBold={true}>
                    {props.valuePrefix && props.valuePrefix}
                    {Number(props.value).toLocaleString()}
                </Body>
                <Body>{props.valueSubtitle}</Body>
            </Stack>
        </div>
    );
};
